import invariant from 'fbjs/lib/invariant';
import { GET } from '../store/lib/xhr';
import interpolate from 'lib/interpolate';

/**
 * for old v1 polls, almost deprecated?
 */
export class CreativesAPI {
  constructor(baseUrl, user_info) {
    invariant(baseUrl, 'Missing required parameters, base url for fetching creatives.');

    this.baseUrl = baseUrl;
    this.defaultLanguage = user_info.lang;
  }

  #query(path) {
    return GET(this.baseUrl + path, [
      [ 'Accept', 'application/json' ]
    ])
  }

  getById(creativeId, lang = this.defaultLanguage){
    const path = interpolate('/landings/get?id={{id}}&lang={{lang}}', {id: creativeId, lang})
    return this.#query(path);
  }

}
